import { useState } from 'react'

import { baseURL } from '@functions/api'

const useExportInvoices = (filters?: Record<string, any>) => {
  const [loadingCsv, setLoadingCsv] = useState(false)

  const searchParams = new URLSearchParams()

  if (filters){
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== ''){
        searchParams.append(key, value.toString())
      }
    })
  }

  const filterQueryParams = filters ? `?${searchParams.toString()}` : ''
  const exportInvoicesCsvUrl = `${baseURL}/invoices/export.csv${filterQueryParams}`

  return {
    exportInvoicesCsvUrl,
    loadingCsv,
    setLoadingCsv,
  }
}

export default useExportInvoices
